import React, { useState, useEffect, useContext } from "react";
import { useMutation } from "@apollo/react-hooks";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/styles";
import { Button, Notification, SimpleGrid, Text } from "@mantine/core";
import { useHistory } from "react-router-dom";
import "./unpaid.css";
import PaymentCountdown from "../Bookings/paymentCountdown";
import moment from "moment";
import gql from "graphql-tag";
import _ from "lodash";
import { AppContext, OPEN_TOAST } from "../Context";
import { uriWithCulture } from "./util";

const PAY_BOOKING = gql`
  mutation initiatePayment {
    initiatePayment {
      uri
    }
  }
`;

// const useStyles = makeStyles((theme) => ({
//   tooltip: {
//     "@media(max-width: 600px)": {
//       bottom: "55px",
//     },
//   },
//   unpaid: {
//     backgroundColor: theme.app.dangerColor,
//     color: "white",
//   },
//   button: {
//     color: "rgba(255,255,255,0.7)",
//   },
// }));

const useStyles = makeStyles((theme) => ({
  wrapper: {
    "&:Button": {
      display: "none",
    },
  },
  tooltip: {
    "@media screen and (max-width: 768px)": {
      bottom: "75px !important",
    },
  },
  closeButton: {
    color: "black !important",
  },
}));

const getState = (state) => ({
  auth: state.oidc.user !== null && !state.oidc.user.expired,
  language: state.language,
});

const Unpaid = (props) => {
  const { mybookings, location, culture } = props;
  const classes = useStyles();
  const context = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const { dispatch } = context;
  const { auth, language } = useSelector((state) => getState(state));
  const handleMutationSuccess = (data) => 
    (window.location = uriWithCulture(data.initiatePayment.uri, culture));
  ;
  const handleMutationError = (error) =>
    dispatch({ type: OPEN_TOAST, toastText: error, toastType: "error" });
  const [initiatePayment] = useMutation(PAY_BOOKING, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });

  let history = useHistory();
  const isOpen = auth
    ? location.pathname === "/bookings"
      ? false
      : open
    : false;

  useEffect(() => {
    const anyUnpaid =
      mybookings.filter((b) => b.isConfirmed && !b.isPaid).length > 0;
    if (anyUnpaid) {
      setOpen(true);
    }
  }, [mybookings]);

  const payableBookings =
    mybookings && mybookings.filter((b) => b.isConfirmed && !b.isPaid);
  const nextPayment = _.chain(payableBookings)
    .filter((x) => x.lastPaymentTime)
    .map((x) => moment(x.lastPaymentTime))
    .sort()
    .min()
    .value();

  const locale = culture.substring(0, 2).toLowerCase();
  const unpaid = mybookings.filter((x) => x.isConfirmed && !x.isPaid).length;

  if (unpaid <= 0) return <div />;

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={isOpen}
        className="snackbarWrapper"
      >
        <Notification
          color="red"
          radius="md"
          title={language?.finishBooking}
          closeButtonProps={{ "aria-label": language.closeAlertDialog }}
          onClose={() => setOpen(false)}
          className={`${classes.wrapper} notificationWrapper`}
          classNames={{ closeButton: classes.closeButton }}
          style={{ fontSize: "1rem" }}
        >
          <Text
            id="message-id"
            sx={(theme) => ({
              color: theme.colors.gray[9],
            })}
          >
            {unpaid < 2
              ? `${language.youHave} ${unpaid} ${language.unpaidBooking}`
              : `${language.youHave} ${unpaid} ${language.unpaidBookings}`}
          </Text>
          <PaymentCountdown
            next={nextPayment}
            locale={locale}
            language={language}
            isNotification={true}
          />
          <SimpleGrid
            mt="xl"
            cols={2}
            spacing="sm"
            breakpoints={[{ maxWidth: 768, cols: 1, spacing: "sm" }]}
          >
            <Button
              color="violet.8"
              variant="outline"
              radius="sm"
              size="sm"
              onClick={() => {
                history.push("/bookings");
              }}
            >
              {language.showMyBookings}
            </Button>
            <Button
              color="violet.8"
              varianti="filled"
              radius="sm"
              size="sm"
              onClick={initiatePayment}
            >
              {language.toPayment}
            </Button>
          </SimpleGrid>
        </Notification>
      </Snackbar>
    </>
  );
};

export default withRouter(Unpaid);
